import { render, staticRenderFns } from "./Createai.vue?vue&type=template&id=1e24671c&scoped=true"
import script from "./Createai.vue?vue&type=script&lang=js"
export * from "./Createai.vue?vue&type=script&lang=js"
import style0 from "./Createai.vue?vue&type=style&index=0&id=1e24671c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e24671c",
  null
  
)

export default component.exports